export default "__VITE_ASSET__VkU3JFyw__"